import { Injectable, Inject } from '@angular/core';
import { WebStorageService, LOCAL_STORAGE } from 'ngx-webstorage-service';
import { User } from 'src/app/model/session/user.model';
import { Router } from '@angular/router';
import { AESEncrypt } from 'src/app/common/Helper/AESEncryp';
import { PerfilBusqueda } from 'src/app/model/session/perfil-busqueda.model';

@Injectable({
  providedIn: 'root'
})

export class SessionSotrageService {

  private currentSession: User = new User();
  aes = new AESEncrypt();

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private router: Router
  ) {
    this.currentSession = this.loadSessionData();
  }

  setCurrentSession(session: User): void {
    this.currentSession = session;
    var content = this.aes.encryptModel(session);
    this.storage.set('currentUser', content);
  }

  setPasswordSession(pw: string):void{
    this.storage.set("currentPassword", this.aes.encrypt(pw));
  }

  getPasswordSession():string{
    return this.aes.decrypt(this.storage.get('currentPassword'));
  }

  loadSessionData(): User {
    let dt = this.storage.get('currentUser');
    let sessionStr = dt == null ? dt : this.aes.decryptModel(dt);
    return (sessionStr) ? sessionStr as User : null;
  }

  getCurrentSession(): User {
    return this.currentSession;
  }

  removeCurrentSession(): void {
    this.storage.remove('currentUser');
    this.storage.remove('currentPassword');
    this.currentSession = null;
  }

  getCurrentUser(): User {
    // tslint:disable-next-line:prefer-const
    let session: User = this.getCurrentSession();
    return (session && session.login) ? session : null;
  }

  isAuthenticated(): boolean {
    return (this.getCurrentToken() != null) ? true : false;
  }

  getCurrentToken(): string {
    // tslint:disable-next-line:prefer-const
    let session = this.getCurrentSession();
    return (session && session.token) ? session.token : null;
  }

  logout(): void {
    this.removeCurrentSession();
    this.router.navigate(['login']);
  }

  setActivateAlert(activate: number): void {
    this.storage.set('activateAlert', activate);
  }

  getActivateAlert(): number {
    return this.storage.get('activateAlert');
  }

  setCSRFToken(token: string) {
    this.storage.set('csrfToken', token);
  }

  getCSRFToken() {
    return this.storage.get('csrfToken');
  }

  setActividadVulnerable(actividadVulnerableId: number):void{
    this.storage.set("actividadVulnerableId", actividadVulnerableId);
  }

  getActividadVulnerable():number{
    return this.storage.get('actividadVulnerableId');
  }

  setlstActividadVulnerable(actividadVulnerable: any):void{
    this.storage.set("lstActividadVulnerable", actividadVulnerable);
  }

  getlstActividadVulnerable():any{
    return this.storage.get('lstActividadVulnerable');
  }


  setSujetoObligado(sujetoObligadoId: number):void{
    this.storage.set("sujetoObligadoId", sujetoObligadoId);
  }

  getSujetoObligado():number{
    return this.storage.get('sujetoObligadoId');
  }

  setAlmacen(almacenId: number):void{
    this.storage.set("almacenId", almacenId);
  }

  getAlmacen():number{
    return this.storage.get('almacenId');
  }

  setPerfilBusqueda(perfil:any):void{
    this.storage.set("perfilBusqueda", perfil);
  }

  getPerfilBusqueda():PerfilBusqueda{
    return this.storage.get('perfilBusqueda');
  }

}
